import { render, staticRenderFns } from "./ListStudent.vue?vue&type=template&id=9f6d5b00"
import script from "./ListStudent.vue?vue&type=script&lang=js"
export * from "./ListStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports